// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"68274ffd","453":"7c4ae419"}[chunkId] + ".chunk.js";
};